import styled from 'styled-components';

const Root = styled.div `
  /* Additional 4px margin for 8px in total */
  .tend-ui-checkbox-group,
  .tend-ui-toggle-group,
  .tend-ui-radio-group {
    margin-top: 4px;
  }

  &:where(.tend-ui-form-field-root-has-error) {
    .tend-ui-form-message-root {
      color: ${props => props.theme.colors.red600};
    }
    .tend-ui-checkbox-inner,
    .tend-ui-picker,
    .tend-ui-select-selector {
      border-color: ${props => props.theme.colors.red600};
    }
  }
  &:where(.tend-ui-form-field-root-has-warning) {
    .tend-ui-form-message-root {
      color: ${props => props.theme.colors.gold600};
    }
  }
  &:where(.tend-ui-form-field-root-has-success) {
    .tend-ui-form-message-root {
      color: ${props => props.theme.colors.green600};
    }
  }
`;

export { Root };
